/**
 * Logica pura dell'ordinamento della FilterBar, isolata qui così da non
 * dipendere dal deprecato `OrderRow` (che verrà cancellato) e da poter essere
 * testata senza React.
 *
 * La query memorizza l'ordinamento nella chiave `ordinamenti`: un array di
 * stringhe in cui conta solo il primo elemento, e il prefisso "-" indica la
 * direzione:
 *   "-dataModifica" → DESC,   "dataModifica" → ASC.
 * (Stesso identico formato del vecchio `OrderRow`.)
 */

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export interface IParsedSort {
  /** Nome del campo di ordinamento (senza prefisso "-"), o `null` se assente. */
  field: string | null;
  direction: SortDirection;
}

/**
 * Scompone il primo elemento di `ordinamenti` in campo + direzione.
 * Se non c'è ordinamento ritorna `{ field: null, direction: Asc }`.
 */
export function parseSort(
  ordinamenti: string[] | null | undefined,
): IParsedSort {
  const raw = ordinamenti?.[0];
  if (!raw) {
    return { field: null, direction: SortDirection.Asc };
  }
  const isDesc = raw.startsWith('-');
  return {
    field: isDesc ? raw.slice(1) : raw,
    direction: isDesc ? SortDirection.Desc : SortDirection.Asc,
  };
}

/**
 * Compone il valore di `ordinamenti` da campo + direzione: "-campo" per DESC,
 * "campo" per ASC. Senza campo ritorna un array vuoto (= nessun ordinamento).
 */
export function buildSort(
  field: string | null,
  direction: SortDirection,
): string[] {
  if (!field) return [];
  return [direction === SortDirection.Desc ? `-${field}` : field];
}
